import { Component } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

interface NavSlot {
  icon: string;
  label: string;
  route: string;
  permission?: string;
}

interface SheetItem {
  icon: string;
  label: string;
  route: string;
  permission?: string;
}

interface SheetGroup {
  label: string;
  items: SheetItem[];
}

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss'],
})
export class BottomNavComponent {
  sheetOpen = false;

  // Spec §4: 5 fixed slots — Dashboard, Lançamentos, Faturas, A pagar, Mais.
  readonly slots: NavSlot[] = [
    { icon: 'dashboard',    label: 'Dashboard',   route: '/dashboard',        permission: 'dashboard' },
    { icon: 'swap_horiz',   label: 'Lançamentos', route: '/transactions',     permission: 'lancamentos' },
    { icon: 'receipt_long', label: 'Faturas',     route: '/invoices',         permission: 'faturas' },
    { icon: 'payments',     label: 'A pagar',     route: '/accounts-payable', permission: 'contas-a-pagar' },
  ];

  // Spec §4: "Mais" opens a bottom sheet with all modules grouped (3-col grid).
  // Mirrors the sidebar groups; permission model is reused verbatim (no new logic).
  readonly sheetGroups: SheetGroup[] = [
    {
      label: 'Financeiro',
      items: [
        { icon: 'swap_horiz',             label: 'Lançamentos', route: '/transactions',     permission: 'lancamentos' },
        { icon: 'payments',               label: 'A pagar',     route: '/accounts-payable', permission: 'contas-a-pagar' },
        { icon: 'account_balance_wallet', label: 'Contas',      route: '/accounts',         permission: 'contas' },
        { icon: 'credit_card',            label: 'Cartão',      route: '/credit-card',      permission: 'cartao-credito' },
        { icon: 'category',               label: 'Categorias',  route: '/categories',       permission: 'categorias' },
      ],
    },
    {
      label: 'Clientes & Faturas',
      items: [
        { icon: 'people_outline', label: 'Clientes',   route: '/clients',           permission: 'clientes' },
        { icon: 'receipt_long',   label: 'Faturas',    route: '/invoices',          permission: 'faturas' },
        { icon: 'query_stats',    label: 'Relatórios', route: '/operation-reports', permission: 'client:report' },
      ],
    },
    {
      label: 'RH',
      items: [
        { icon: 'badge',     label: 'Funcionários', route: '/employees',         permission: 'funcionarios' },
        { icon: 'handshake', label: 'Prestadores',  route: '/service-providers', permission: 'service-providers' },
        { icon: 'cake',      label: 'Aniversários', route: '/birthdays',         permission: 'aniversariantes' },
      ],
    },
    {
      label: 'Usuários',
      items: [
        { icon: 'people',               label: 'Usuários', route: '/users', permission: 'usuarios' },
        { icon: 'admin_panel_settings', label: 'Papéis',   route: '/roles', permission: 'configuracoes' },
      ],
    },
    {
      label: 'Sistema',
      items: [
        { icon: 'assessment',     label: 'Relatórios',    route: '/reports',     permission: 'relatorios' },
        { icon: 'manage_history', label: 'Logs',          route: '/logs',        permission: 'configuracoes' },
        { icon: 'bug_report',     label: 'Testes',        route: '/test-runner', permission: 'configuracoes' },
        { icon: 'terminal',       label: 'SQL Editor',    route: '/sql-editor',  permission: 'sql_editor' },
        { icon: 'settings',       label: 'Configurações', route: '/settings' },
      ],
    },
  ];

  constructor(public auth: AuthService) {}

  isVisible(item: { permission?: string }): boolean {
    if (!item.permission) return true;
    return this.auth.hasPermission(item.permission);
  }

  groupHasVisible(group: SheetGroup): boolean {
    return group.items.some((i) => this.isVisible(i));
  }

  openSheet(): void {
    this.sheetOpen = true;
  }

  closeSheet(): void {
    this.sheetOpen = false;
  }
}
